
<script>
import debounce from 'lodash/debounce';

export default {
  name: 'SeoHeader',
  data() {
    return {
      user_action: false
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    userAction() {
      this.user_action = true;
    },
   handleScroll: debounce(function() {
    if (!this.user_action) {
      const collapseHeaderTextElement = document.getElementById('collapseHeaderText');
      const collapseTriggerElement = document.querySelector('[data-toggle="collapse"][href="#collapseHeaderText"]');

      if (collapseHeaderTextElement && collapseTriggerElement) {
        collapseHeaderTextElement.classList.remove('show');
        collapseTriggerElement.setAttribute('aria-expanded', 'false');
      }
    }}, 300), // Debounce to limit the rate of function execution
  }
};
</script>